import LanguageForm from './LanguageForm'

const Create = () => {
    return (
        <LanguageForm
            config={{
                submitSuccessMsg: {
                    header: 'Created',
                    message: 'Language created successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to create language',
                },
                saveButton: {
                    label: 'Create',
                    savingLabel: 'Creating language...',
                },
            }}
        />
    )
}

export default Create
